'use client';

/**
 * @deprecated This hook is deprecated. Framer Motion has been removed for performance.
 * Use SmoothReveal component with CSS-only animations instead.
 * 
 * This file is kept for backward compatibility to export constants and types.
 * The actual hook implementation is a stub and should not be used.
 */

import { useRef } from 'react';

export type SmoothVariant =
  | 'fade'
  | 'fade-up'
  | 'fade-down'
  | 'fade-left'
  | 'fade-right';

// Constants moved to animation-constants.ts for better code organization
// Re-export for backward compatibility
export { 
  SMOOTH_IN_VIEW_DURATION, 
  SMOOTH_IN_VIEW_EASE, 
  SMOOTH_IN_VIEW_STAGGER 
} from './animation-constants';

// Stub types for backward compatibility (used by deprecated SmoothRevealFramerMotion)
export type Variants = Record<string, unknown>;
export type Variant = Record<string, unknown>;

export interface UseSmoothInViewAnimationOptions {
  variant?: SmoothVariant;
  distance?: number;
  delay?: number;
  margin?: string;
  once?: boolean;
  disabled?: boolean;
  customVariants?: Variants;
}

/**
 * @deprecated This hook is deprecated. Use SmoothReveal component instead.
 * This is a stub implementation that returns empty values for backward compatibility.
 */
export function useSmoothInViewAnimation(
  _options: UseSmoothInViewAnimationOptions = {}
) {
  const ref = useRef<HTMLElement | null>(null);
  
  // Return stub values for backward compatibility
  // These match the expected return type from framer-motion hooks
  return {
    ref,
    controls: {
      set: () => {},
      start: () => Promise.resolve(),
    } as any,
    variants: {},
  };
}

// Stub variants for backward compatibility
export const smoothFadeVariants: Variants = {};
export const smoothFadeUpVariants: Variants = {};
export const smoothFadeDownVariants: Variants = {};
export const smoothFadeLeftVariants: Variants = {};
export const smoothFadeRightVariants: Variants = {};

